import { Box, LinearProgress, Stack, Typography } from '@mui/material'

import { useController } from '../../hooks/useController'
import { useTexts } from '../../useTexts'
import { OutcomeRow } from './OutcomeRow'
import { getStrategyVariant } from './strategyExampleVariants'

export function StrategyExamplePanel() {
  const texts = useTexts()
  const {
    data: { strategy, driverUsage, balanceBy },
  } = useController()

  const variant = getStrategyVariant(strategy, driverUsage, balanceBy, texts)

  const strategyLabel = strategy === 'fleetSavings' ? texts.fleetSavings : texts.balancedPerformance

  return (
    <Stack spacing={2}>
      <Stack spacing={0.5}>
        <Typography variant="body2" fontSize="16px">
          {texts.strategyExampleTitle(strategyLabel)}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {texts.strategyExampleDisclaimer}
        </Typography>
      </Stack>

      <Stack spacing={0.5}>
        {variant.bars.map(bar => (
          <Stack
            key={bar.letter}
            direction="row"
            alignItems="center"
            spacing={2}
            sx={{
              minHeight: 28,
              px: 2,
              py: 1,
              bgcolor: t => t.vars.palette.background.paper,
              borderRadius: 1,
            }}
          >
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ minWidth: 110, fontSize: '12px' }}
            >
              {texts.sampleVehicle(bar.letter)}
            </Typography>
            <Box flex={1}>
              <LinearProgress
                variant="determinate"
                value={bar.value ?? 0}
                color={variant.barColor}
                sx={{
                  height: 8,
                  borderRadius: 1,
                  opacity: bar.value === null ? 0.35 : 1,
                }}
              />
            </Box>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ minWidth: 32, textAlign: 'right' }}
            >
              {bar.value !== null ? `${bar.value}%` : '-'}
            </Typography>
          </Stack>
        ))}
      </Stack>

      <Stack
        spacing={2}
        sx={{
          p: 2,
          bgcolor: t => t.vars.palette.background.paper,
          borderRadius: 1,
        }}
      >
        <Typography variant="subtitle2">{texts.typicalOutcome}</Typography>
        <OutcomeRow label={texts.outcomeVehicleUsage} value={variant.outcome.vehicleUsage} />
        <OutcomeRow
          label={texts.outcomeTravelEfficiency}
          value={variant.outcome.travelEfficiency}
        />
        <OutcomeRow
          label={texts.outcomeWorkloadFairness}
          value={variant.outcome.workloadFairness}
        />
        <OutcomeRow label={texts.outcomeLoadSaturation} value={variant.outcome.loadSaturation} />
      </Stack>
    </Stack>
  )
}
